import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

// Preventivo da autorizzare: arriverà una notifica quando sarà generato
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-quote-authorization-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <mat-dialog-content class="quote-content">
      <div class="quote-icon">
        <i class="fa-solid fa-circle-info"></i>
      </div>
      <span class="title-medium">{{ 'orders.ui.richiestaAutorizzazione' | transloco }}</span>
      <span class="body-medium quote-box">
        {{ 'orders.ui.ilSeguentePreventivo' | transloco }} <strong>{{ 'orders.ui.necessitaDiAutorizzazione' | transloco }}</strong>{{ 'orders.ui.lUtenteSaraNotificatoUnaVoltaGeneratoIlPreventivo' | transloco }}
      </span>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button matButton="filled" type="button" class="quote-close" mat-dialog-close>{{ 'orders.ui.chiudi' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .quote-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--mat-sys-spacing-8);
    }

    .quote-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 100%;
      color: var(--mat-sys-on-info-container);
      background-color: var(--mat-sys-info-container);
    }

    .quote-box {
      padding: var(--mat-sys-spacing-8);
      border-radius: var(--mat-sys-corner-medium);
      background-color: var(--mat-sys-info-container);
    }

    .quote-close {
      width: 100%;
    }
  `,
})
export class QuoteAuthorizationDialog {}
